<!--
 * @Author: yaolunmao
-->
<template>
  <component :is="component_prop.type" :prop_data="component_prop"></component>
</template>
<script>
import Vue from 'vue'
let importComponents = {}
export default {
  components: importComponents,
  props: ['svgInfoData', 'component_prop'],
  data() {
    return {
      componentTag: ''
    }
  },
  provide: {},
  created() {
    this.svgInfoData.forEach((f, i) => {
      let componentInfo = {
        template: f.template,
        props: f.props
      }
      Vue.component(f.type, componentInfo)
      importComponents[f.type] = componentInfo
    })
  },
  methods: {}
}
</script>
<style scoped></style>
